import PaymentHistory from "../components/dashboard/PaymentHistory";

const PaymentPage = () => {
  return (
    <div className="payment-page">
      <header className="payment-page__header">
        <h1>Pagos y Transacciones</h1>
        <p className="payment-page__subtitle">
          Gestiona tus pagos y revisa tu historial de transacciones
        </p>
        <p className="payment-page__subtitle--warning">El pago se hará el mes siguiente a la fecha de solicitud debido a validaciones internas.</p>
      </header>

      <div className="payment-page__content">
        <PaymentHistory />
      </div>
    </div>
  );
};

export default PaymentPage;
